import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Table,
  Button,
  Row,
  Col,
  Spinner
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import api from '../../utils/api';

const ActivistsList = (props) => { // ✅ غيرت الاسم
  const [activists, setActivists] = useState([]); // ✅ غيرت الاسم
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    props.setBreadcrumbItems('الناشطين', [
      { title: "الرئيسية", link: "/dashboard" },
      { title: "الناشطين", link: "#" }
    ]);
  }, [props]);

  useEffect(() => {
    fetchActivists(); // ✅ غيرت الاسم
  }, []);

  const fetchActivists = async () => { // ✅ غيرت الاسم
    try {
      const response = await api.get('/activists');
      setActivists(response.data.data); // ✅ غيرت الاسم
    } catch (error) {
      console.error('Error fetching activists:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد من حذف هذا الناشط؟")) return;
    try {
      await api.delete(`/activists/${id}`); // ✅ صححت للـ DELETE
      alert("تم حذف الناشط بنجاح");
      fetchActivists(); // ✅ غيرت الاسم
    } catch (error) {
      console.error('فشل حذف الناشط:', error);
      alert("حدث خطأ أثناء حذف الناشط");
    }
  };

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row className="mb-4">
            <Col md={6}>
              <CardTitle className="h4">قائمة الناشطين</CardTitle>
            </Col>
            <Col md={6} className="text-end">
              <Link to="/dashboard/activists/create">
                <Button color="primary">
                  <i className="mdi mdi-plus me-1"></i> إضافة ناشط جديد
                </Button>
              </Link>
            </Col>
          </Row>

          {loading ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <div className="table-responsive">
              <Table className="table align-middle table-bordered table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>الاسم الكامل</th>
                    <th>المدينة/المنطقة</th>
                    <th>رقم الجوال</th>
                    <th>البريد الإلكتروني</th>
                    <th style={{width: '200px'}}>إجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {activists.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center">لا يوجد ناشطين حالياً</td>
                    </tr>
                  ) : (
                    activists.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.full_name}</td>
                        <td>{item.city_or_area || '-'}</td>
                        <td>{item.mobile1 || '-'}</td>
                        <td>{item.email || '-'}</td>
                        <td>
                          <div className="d-flex gap-1">
                            <Link to={`/dashboard/activists/view/${item.id}`}>
                              <Button size="sm" color="success" className="me-1">
                                <i className="mdi mdi-eye me-1"></i>
                                عرض
                              </Button>
                            </Link>
                            
                            <Link to={`/dashboard/activists/edit/${item.id}`}>
                              <Button size="sm" color="info" className="me-1">
                                <i className="mdi mdi-pencil me-1"></i>
                                تعديل
                              </Button>
                            </Link>

                           <Button
                             size="sm"
                             color="warning"
                             className="me-1"
                             onClick={() => window.open(`/dashboard/activists/print/${item.id}`, '_blank')}
                           >
                             <i className="mdi mdi-file-pdf me-1"></i>
                             PDF
                           </Button>

                           <Button
                             size="sm"
                             color="secondary"
                             className="me-1"
                             onClick={() => window.open(`/dashboard/activists/print/${item.id}`, '_blank')}
                           >
                             <i className="mdi mdi-printer me-1"></i>
                             طباعة
                           </Button>                            <Button
                              size="sm"
                              color="danger"
                              onClick={() => handleDelete(item.id)}
                            >
                              <i className="mdi mdi-delete me-1"></i>
                              حذف
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(ActivistsList); // ✅ غيرت الاسم